
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface FormFieldProps {
  id: string;
  label: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  required?: boolean;
  isInvalid?: boolean;
  validationMessage?: string;
  showRequirements?: boolean;
}

export const FormField = ({
  id,
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  error,
  required = false,
  isInvalid = false,
  validationMessage,
  showRequirements = false
}: FormFieldProps) => {
  const hasError = error || isInvalid;
  
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      {showRequirements && validationMessage && (
        <p className="text-sm text-red-500 bg-red-50 p-2 rounded border border-red-200">
          {validationMessage}
        </p>
      )}
      <Input 
        id={id} 
        type={type} 
        placeholder={placeholder} 
        value={value}
        onChange={onChange}
        required={required}
        className={hasError ? "border-red-500" : ""}
      />
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};
